// extracted by mini-css-extract-plugin
export default {"onHover":"Comps_onHover__BD07Z","question":"Comps_question__zaD0Z","list":"Comps_list__NtXuf","bubbleB":"Comps_bubbleB__S6MRa","listItem":"Comps_listItem__E3kqO"};